<template>
  <div>
    <base-button block type="primary" class="m-0" @click="modal = true">
      {{ $t('ptStops.create.btnLabel') }}
    </base-button>

    <modal :show.sync="modal"
           showClose
           modal-classes="modal-dialog-centered modal-lg"
           @close="resetForm()">
      <template slot="header">
        <h4 class="modal-title">
          {{ $t('ptStops.create.titleText') }}
        </h4>
      </template>
      <template>
        <div class="text-center text-muted mb-4">
          <small>{{ $t('ptStops.create.helpText') }}</small>
        </div>
        <base-alert v-if="alert" dismissible :dismiss-callback="() => alert=false" type="danger">
          <!-- TODO: add error translation -->
          {{ getActionErrorDetails }}
        </base-alert>
        <form role="form" @submit.prevent="validate()">
          <div class="row">
            <label class="col-sm-3 col-form-label">{{ $t('ptStops.details.stop_id') }}</label>
            <div class="col-md-9">
              <base-input
                data-vv-as="'stop_id'"
                name="stop_id"
                v-validate="modelValidations.required"
                :error="getError('stop_id')"
                v-model="formDetails.stop_id">
              </base-input>
            </div>
          </div>

          <div class="row">
            <label class="col-sm-3 col-form-label">{{ $t('ptStops.details.name') }}</label>
            <div class="col-md-9">
              <base-input
                data-vv-as="'name'"
                name="name"
                v-validate="modelValidations.required"
                :error="getError('name')"
                v-model="formDetails.name">
              </base-input>
            </div>
          </div>

          <div class="row">
            <label class="col-sm-3 col-form-label">{{ $t('ptStops.details.zone_id') }}</label>
            <div class="col form-group">
              <el-select
                class="select-primary"
                name="zone_id"
                v-model="formDetails.zone_id"
              >
                <el-option
                  v-for="option in ptZones"
                  class="select-primary"
                  :value="option.id"
                  :label="option.id"
                  :key="option.id"
                >
                </el-option>
              </el-select>
            </div>
          </div>

          <div class="row">
            <label class="col-sm-3 col-form-label">{{ $t('ptStops.details.municipality_id') }}</label>
            <div class="col form-group">
              <el-select
                class="select-primary"
                name="zone_id"
                v-model="formDetails.municipality_id"
              >
                <el-option
                  v-for="option in municipalities"
                  class="select-primary"
                  :value="option.id"
                  :label="option.id"
                  :key="option.id"
                >
                </el-option>
              </el-select>
            </div>
          </div>

          <div class="row">
            <label class="col-sm-3 col-form-label">{{ $t('ptStops.details.pavilion') }}</label>
            <div class="col-sm-9">
              <base-checkbox
                inline
                v-model="formDetails.info.pavilion"
              ></base-checkbox>
            </div>
          </div>
          <div class="row">
            <label class="col-sm-3 col-form-label">{{ $t('ptStops.details.voice_tag') }}</label>
            <div class="col-sm-9">
              <base-checkbox
                inline
                v-model="formDetails.info.voice_tag"
              ></base-checkbox>
            </div>
          </div>
          <div class="row">
            <label class="col-sm-3 col-form-label">{{ $t('ptStops.details.digital_display') }}</label>
            <div class="col-sm-9">
              <base-checkbox
                inline
                v-model="formDetails.info.digital_display"
              ></base-checkbox>
            </div>
          </div>
          <div class="row">
            <label class="col-sm-3 col-form-label">{{ $t('ptStops.details.paper_schedule') }}</label>
            <div class="col-sm-9">
              <base-checkbox
                inline
                v-model="formDetails.info.paper_schedule"
              ></base-checkbox>
            </div>
          </div>
          <div class="row">
            <label class="col-sm-3 col-form-label">{{ $t('ptStops.details.metadata') }}</label>
            <div class="col-md-9">
              <base-input
                data-vv-as="'metadataKeyVal'"
                name="metadataKeyVal"
                v-validate="modelValidations.validMetadata"
                :error="getError('metadataKeyVal')"
                v-model="formDetails.info.metadataKeyVal">
              </base-input>
            </div>
          </div>

          <div class="text-center">
            <base-button
              type="primary"
              :loading="updating"
              class="my-4"
              native-type="submit"
            >{{ $t('ptStops.create.actionBtnLabel') }}
            </base-button>
          </div>
        </form>
      </template>
    </modal>
  </div>
</template>


<script>
import {BaseAlert, Modal} from 'src/components';
import {Option, Select} from 'element-ui';
import {mapActions, mapState} from "vuex";

export default {
  name: 'new-pt-stop-btn',
  components: {
    [Option.name]: Option,
    [Select.name]: Select,
    Modal,
    BaseAlert
  },
  props: {
    ptZones: {
      type: Array,
      required: true,
    },
    municipalities: {
      type: Array,
      required: true,
    }
  },
  data() {
    return {
      modal: false,
      alert: false,
      loading: false,
      formDetails: {
        stop_id: '',
        zone_id: '',
        name: '',
        municipality_id: '',
        info: {
          pavilion: false,
          voice_tag: false,
          digital_display: false,
          paper_schedule: false,
          metadataKeyVal: ""
        }
      },
      modelValidations: {
        required: {
          required: true
        },
        validMetadata: {
          metadataObj: true
        },
      }
    }
  },

  computed: {
    ...mapState({
      updating: state => state.pt_stop.updating,
      error: state => state.pt_stop.error,
    }),
    getActionErrorDetails() {
      return this.error ? this.error.bodyText : null;
    }
  },
  methods: {
    ...mapActions(['CreatePtStop', 'GetPTStops']),
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate: function () {
      this.$validator.validateAll().then(isValid => {
        if (isValid) {
          this.create()
        }
      });
    },
    create: function () {
      let payload = {
        stop_id: this.formDetails.stop_id,
        zone_id: this.formDetails.zone_id,
        municipality_id: this.formDetails.municipality_id,
        name: this.formDetails.name,
        info: {
          pavilion: this.formDetails.info.pavilion,
          voice_tag: this.formDetails.info.voice_tag,
          digital_display: this.formDetails.info.digital_display,
          paper_schedule: this.formDetails.info.paper_schedule,
        }
      }

      try {
        let metadataObj = JSON.parse(this.formDetails.info.metadataKeyVal)
        payload.info["metadata"] = metadataObj;
      } catch (e) {
        console.log("failed parse ", this.formDetails.info.metadataKeyVal, e)
      }

      this.CreatePtStop(payload).then(() => {
        if (this.error != null) {
          this.alert = true
          // got error, don't reset form
        } else {
          this.GetPTStops();
          this.resetForm();
          this.$notify({
            type: 'success',
            message: this.$t('ptStops.create.createdNotification', payload),
            icon: 'tim-icons icon-alert-circle-exc'
          })
        }
      });
    },
    resetForm: function () {
      // closing dialog
      this.modal = false;

      // resetting alerts
      this.alert = false;

      // resetting form
      this.formDetails = {
        stop_id: '',
        zone_id: '',
        name: '',
        municipality_id: '',
        info: {
          pavilion: false,
          voice_tag: false,
          digital_display: false,
          paper_schedule: false,
          metadataKeyVal: ""
        }
      };

      // reset validation errors
      this.$validator.reset()
    }
  },
  mounted() {
  },
}
</script>
